import { z } from 'zod/v4';

export const organizationRoleSchema = z.enum(['owner', 'admin', 'member', 'viewer']);

export const organizationMembershipSummarySchema = z.object({
    id: z.string().optional().default(''),
    role: organizationRoleSchema,
    joinedAt: z.string().optional().default('')
});

export const organizationSchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string().optional().default(''),
    billingPlan: z.string().optional().default(''),
    isActive: z.boolean().optional().default(true),
    hasActivePlatformAccess: z.boolean().optional(),
    isDeleted: z.boolean().optional().default(false),
    createdAt: z.string().optional().default(''),
    updatedAt: z.string().optional().default(''),
    membership: organizationMembershipSummarySchema
});

export const organizationsListSchema = z.array(organizationSchema);

export const createOrganizationInputSchema = z.object({
    name: z.string().trim().min(2, 'Organization name must be at least 2 characters long'),
    slug: z
        .string()
        .trim()
        .min(2, 'Slug must be at least 2 characters long')
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug must use lowercase letters, numbers, and hyphens only')
        .optional()
        .or(z.literal(''))
});

export type Organization = z.infer<typeof organizationSchema>;
export type OrganizationRole = z.infer<typeof organizationRoleSchema>;
export type CreateOrganizationInput = z.infer<typeof createOrganizationInputSchema>;
